import { observable, makeObservable } from 'mobx';
import { createModelSchema, primitive, object } from 'serializr';

import { Coords } from '@vromo/models';
import { optional } from '@vromo/models';

export type GeozoneType = 'arrival' | 'departure';

export class Geozone {
    id: number | null = null;
    created: number | null = null;
    name = '';
    address = '';
    coords: Coords = new Coords();
    radius = 50;
    type?: GeozoneType

    constructor() {
        makeObservable(this, {
            name: observable,
            address: observable,
            coords: observable,
            radius: observable,
            type: observable
        });
    }
}

createModelSchema(Geozone, {
    id: optional(primitive()),
    created: optional(primitive()),
    name: primitive(),
    address: primitive(),
    coords: object(Coords),
    radius: primitive(),
    type: primitive()
});
